<div class="properties-panel">
    <h3 class="panel-title">Properties</h3>

    @if (selectedCount() === 0) {
        <div class="empty-state">
            <p>Select an object to view properties</p>
        </div>
    } @else {
        @if (selectedObject(); as obj) {
            <div class="property-section">
                <h4>Position & Size</h4>
                <div class="property-grid">
                    <label>
                        X
                        <input
                            type="number"
                            [value]="obj.position.x"
                            (input)="updatePosition('x', $event)"/>
                    </label>
                    <label>
                        Y
                        <input
                            type="number"
                            [value]="obj.position.y"
                            (input)="updatePosition('y', $event)"/>
                    </label>
                    <label>
                        W
                        <input
                            type="number"
                            [value]="obj.size.width"
                            (input)="updateSize('width', $event)"/>
                    </label>
                    <label>
                        H
                        <input
                            type="number"
                            [value]="obj.size.height"
                            (input)="updateSize('height', $event)"/>
                    </label>
                </div>
            </div>

            <div class="property-section">
                <h4>Transform</h4>
                <div class="property-grid">
                    <label>
                        Rotation
                        <input
                            type="number"
                            [value]="obj.transform.rotation"
                            (input)="updateRotation($event)"/>
                    </label>
                    <label>
                        Scale X
                        <input
                            type="number"
                            step="0.1"
                            [value]="obj.transform.scaleX"
                            (input)="updateScale('scaleX', $event)"/>
                    </label>
                    <label>
                        Scale Y
                        <input
                            type="number"
                            step="0.1"
                            [value]="obj.transform.scaleY"
                            (input)="updateScale('scaleY', $event)"/>
                    </label>
                    <label>
                        Opacity
                        <input
                            type="range"
                            min="0"
                            max="1"
                            step="0.01"
                            [value]="obj.opacity"
                            (input)="updateOpacity($event)"/>
                        <span>{{ (obj.opacity * 100).toFixed(0) }}%</span>
                    </label>
                </div>
            </div>

            @if (obj.type === 'rectangle' || obj.type === 'triangle' || obj.type === 'diamond' || obj.type === 'pentagon' || obj.type === 'hexagon' || obj.type === 'star' || obj.type === 'heart' || obj.type === 'check' || obj.type === 'arrow' || obj.type === 'cloud' || obj.type === 'text' || obj.type === 'image' || obj.type === 'frame' || obj.type === 'polygon') {
                <div class="property-section">
                    <h4>Corner Radius</h4>
                    <label>
                        <input
                            type="number"
                            min="0"
                            [value]="getCornerRadius(obj)"
                            (input)="updateCornerRadius($event)"/>
                    </label>
                </div>
            }

            @if (obj.type === 'text') {
                <div class="property-section">
                    <h4>Text</h4>
                    <label>
                        Content
                        <textarea
                            [(ngModel)]="obj.content"
                            (ngModelChange)="updateTextContent($event);"
                            (keydown)="$event.stopPropagation(); $event.stopImmediatePropagation();"
                            (keyup)="$event.stopPropagation(); $event.stopImmediatePropagation();"
                            rows="5"></textarea>
                    </label>
                    <div class="property-grid">
                        <label>
                            Font Family
                            <select
                                [value]="obj.textStyle.fontFamily"
                                (change)="updateTextStyle('fontFamily', $event)">
                                @for (font of googleFonts; track font) {
                                    <option [value]="font">{{ font }}</option>
                                }
                            </select>
                        </label>
                        <label>
                            Font Size
                            <input
                                type="number"
                                [value]="obj.textStyle.fontSize"
                                (input)="updateTextStyle('fontSize', $event)"/>
                        </label>
                        <label>
                            Font Weight
                            <select
                                [value]="obj.textStyle.fontWeight"
                                (change)="updateTextStyle('fontWeight', $event)">
                                <option value="normal">Normal</option>
                                <option value="bold">Bold</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="300">300</option>
                                <option value="400">400</option>
                                <option value="500">500</option>
                                <option value="600">600</option>
                                <option value="700">700</option>
                                <option value="800">800</option>
                                <option value="900">900</option>
                            </select>
                        </label>
                        <label>
                            Text Align
                            <select
                                [value]="obj.textStyle.textAlign"
                                (change)="updateTextStyle('textAlign', $event)">
                                <option value="left">Left</option>
                                <option value="center">Center</option>
                                <option value="right">Right</option>
                            </select>
                        </label>
                    </div>
                </div>
            }

            <div class="property-section">
                <h4>Fill</h4>
                @if (obj.fill) {
                    <div class="color-picker">
                        <input
                            type="color"
                            [value]="rgbaToHex(obj.fill)"
                            (input)="updateFillColor($event)"/>
                        <label>
                            Alpha
                            <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.01"
                                [value]="obj.fill.a"
                                (input)="updateFillAlpha($event)"/>
                            <span>{{ (obj.fill.a * 100).toFixed(0) }}%</span>
                        </label>
                    </div>
                } @else {
                    <button class="add-button" (click)="addFill()">Add Fill</button>
                }
            </div>

            <div class="property-section">
                <h4>Stroke</h4>
                @if (obj.stroke) {
                    <div class="color-picker">
                        <input
                            type="color"
                            [value]="rgbaToHex(obj.stroke.color)"
                            (input)="updateStrokeColor($event)"/>
                        <label>
                            Width
                            <input
                                type="number"
                                min="0"
                                [value]="obj.stroke.width"
                                (input)="updateStrokeWidth($event)"/>
                        </label>
                    </div>
                } @else {
                    <button class="add-button" (click)="addStroke()">Add Stroke</button>
                }
            </div>

            @if (obj.type === 'svg' && hasSVGLayers(obj)) {
                <div class="property-section">
                    <h4>SVG Colors</h4>
                    <div class="svg-color-palette">
                        @for (color of getUniqueColors(obj); track color) {
                            <div class="color-palette-item">
                                <input
                                    type="color"
                                    [value]="svgColorToHex(color)"
                                    (change)="updateAllLayersWithColor(obj.id, color, $event)"/>
                                <span class="color-label">{{ svgColorToHex(color) }}</span>
                            </div>
                        }
                    </div>
                </div>

                <div class="property-section">
                    <h4>SVG Layers</h4>
                    <div class="svg-layers">
                        @for (layer of getSVGLayers(obj); track layer.id) {
                            <div
                                class="layer-item"
                                #svgLayerItem
                                [attr.data-layer-id]="layer.id"
                                [class.layer-active]="obj.selectedLayerId === layer.id">
                                <div class="layer-name">{{ layer.name }}</div>
                                <div class="layer-colors">
                                    @if (getSVGLayerFill(layer) && getSVGLayerFill(layer) !== 'none') {
                                        <label>
                                            <span>Fill</span>
                                            <input
                                                type="color"
                                                [value]="svgColorToHex(getSVGLayerFill(layer))"
                                                (change)="updateSVGLayerFill(obj.id, layer.id, $event)"/>
                                        </label>
                                    }
                                    @if (getSVGLayerStroke(layer) && getSVGLayerStroke(layer) !== 'none') {
                                        <label>
                                            <span>Stroke</span>
                                            <input
                                                type="color"
                                                [value]="svgColorToHex(getSVGLayerStroke(layer))"
                                                (change)="updateSVGLayerStroke(obj.id, layer.id, $event)"/>
                                        </label>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }

            <div class="property-section">
                <h4>Arrangement</h4>
                <div class="arrangement-buttons">
                    <button (click)="bringToFront()">Bring to Front</button>
                    <button (click)="sendToBack()">Send to Back</button>
                </div>
            </div>

            <div class="property-section">
                <h4>Visibility</h4>
                <div class="checkbox-row">
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            [checked]="obj.visible"
                            (change)="toggleVisibility()"/>
                        Visible
                    </label>
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            [checked]="obj.locked"
                            (change)="toggleLocked()"/>
                        Locked
                    </label>
                </div>
            </div>
        }

        @if (selectedCount() > 1) {
            <div class="property-section">
                <h4>Align</h4>
                <div class="align-grid">
                    <button class="align-button" (click)="alignLeft()">Align Left</button>
                    <button class="align-button" (click)="alignCenterHorizontal()">Align Horizontal Center</button>
                    <button class="align-button" (click)="alignRight()">Align Right</button>
                    <button class="align-button" (click)="alignTop()">Align Top</button>
                    <button class="align-button" (click)="alignCenterVertical()">Align Vertical Center</button>
                    <button class="align-button" (click)="alignBottom()">Align Bottom</button>
                </div>
            </div>

            <div class="property-section">
                <h4>Spacing</h4>
                <div class="align-grid">
                    <button class="align-button" [disabled]="selectedCount() < 3" (click)="tidyUp()">Tidy Up</button>
                    <button class="align-button" [disabled]="selectedCount() < 3" (click)="distributeVertical()">Distribute Vertical Spacing</button>
                    <button class="align-button" [disabled]="selectedCount() < 3" (click)="distributeHorizontal()">Distribute Horizontal Spacing</button>
                </div>
            </div>
        }
    }
</div>
